import { LocalTime } from "@js-joda/core";

export const SCHEDULE_HOURS = Array.from(Array(24).keys()).map((hour) => LocalTime.of(hour));
